import c from './index.module.scss'
const Button = ({onClick, Icon, text}) => {
    return (
        <button className={c.button} onClick={onClick}>
            <Icon />  {text}
        </button>
    );
};

export default Button;